<template>
  <b-server-table
    :key="renderKey"
    :filter-props="{
      filterMap: [
        {
          key: 'search',
        },
        {
          key: 'departmentId',
          directory: 'departmentList',
          component: 'select',
        },
        {
          key: 'typeId',
          directory: 'protocolTypes',
          component: 'select',
        },
        {
          key: 'directionId',
          directory: 'protocolDirections',
          component: 'select',
        },
        {
          key: 'issuedUserId',
          directory: 'userList',
          component: 'autocomplete',
        },
        {
          key: 'fromDate',
          component: 'input-date',
        },
        {
          key: 'toDate',
          component: 'input-date',
        },
        {
          key: 'isActive',
          component: 'checkbox',
        },
      ],
    }"
    :headers="protocolListHeaders"
    :request-func="getProtocols"
    @click:row="openRow">
    <template #action-button>
      <div
        v-if="[USER_ROLE.ADMIN, USER_ROLE.CLERKSHIP].includes(user.roleId)"
        class="d-flex ga-3">
        <v-btn rounded="lg" @click.stop="familiarizationReportDialog">
          <v-icon class="mr-1" style="color: #fff"
            >{{ 'mdi-cloud-print-outline' }}
          </v-icon>
          Сформувати звіт
        </v-btn>
        <v-btn
          v-if="can('protocols.create')"
          rounded="lg"
          @click.stop="createProtocol">
          <v-icon class="mr-1">mdi-plus</v-icon>
          Створити протокол
        </v-btn>
      </div>
    </template>
    <template #item.issuedUser="{ item }">
      <span v-if="item.issuedUser">
        {{ getPersonName(item.issuedUser) }}
      </span>
      <span v-else class="text-disabled">Не вказано</span>
    </template>
    <template #item.isActive="{ item }">
      <span>{{ item.isActive ? 'Активний' : 'Неактивний' }}</span>
    </template>
    <template #item.name="{ item }">
      <v-tooltip :text="item.name" bottom>
        <template #activator="{ props }">
          <span
            style="
              display: block;
              width: 350px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            "
            v-bind="props">
            {{ item.name }}
          </span>
        </template>
      </v-tooltip>
    </template>
    <template #bottom></template>
  </b-server-table>
</template>

<script lang="ts">
import { axios, useBreadcrumb } from '@/plugins/index.js'
import { computed, ref } from 'vue'
import { navigateToItem } from '@/utils/helpers.js'
import { urlProtocolList } from '@/utils/urls.js'
import { openDialog } from '@/dialog'
import { useStore } from 'vuex'
import { BServerTable } from 'best-modules/components'
import { getPersonName } from 'best-modules/utils'
import { protocolListHeaders } from '@/utils/tableHeaders'
import { USER_ROLE } from '@/utils/constants'
import { useCan } from '@/composables/useCan'

export default {
  components: { BServerTable },
  data: () => ({
    USER_ROLE,
    protocolListHeaders,
  }),
  methods: { getPersonName },
  setup() {
    const store = useStore()
    const renderKey = ref(1)
    const breadcrumb = useBreadcrumb()
    const { can } = useCan()
    breadcrumb.set([], { type: 'replace' })

    const user = computed(() => store.state.user.userData || {})

    const openRow = (event: any) => {
      navigateToItem('single-protocol', event.id)
    }

    const getProtocols = (query: any) => {
      return axios.get(urlProtocolList(query)).then(res => res.data)
    }

    const familiarizationReportDialog = () => {
      openDialog({
        name: 'FamiliarizationReport',
        action: 'create',
      })
    }

    const createProtocol = () => {
      openDialog({
        name: 'Protocol',
        action: 'create',
        params: {
          cb: protocol => {
            navigateToItem('single-protocol', protocol.id)
          },
          submitLabel: 'Створити',
        },
      })
    }

    return {
      renderKey,
      getProtocols,
      navigateToItem,
      familiarizationReportDialog,
      openRow,
      user,
      createProtocol,
      can,
    }
  },
}
</script>

<style lang="scss" scoped></style>
